import { Badge } from '@heidi/design-system/badge';
import { FormattedMessage } from 'react-intl';

import type { JSX } from 'react';

/**
 * Consistent badge used in ReferenceCard and SourceCard to indicate that a
 * citation comes from an integration partner (e.g., DynaMed).
 */
export function IntegrationPartnerBadge(): JSX.Element {
  return (
    <Badge color="proTier" size="sm" data-testid="integration-partner-badge">
      <FormattedMessage
        defaultMessage="Clinical Resource"
        id="540ZFVs9iJ"
        description="Badge marking a citation sourced from an integration partner such as DynaMed"
      />
    </Badge>
  );
}
